module.exports = __webpack_public_path__ + "img/benefit_bids_councils.3f28a179.jpeg";